import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const recommendationService = {
    getAllRecommendations,
    updateRecommendationStatus,
    getRecommendation,
    updateRecommendation,
    createRecommendation,
};

const MODULE = {
    RECOMMENDATION: 'rnd-product-recommendations',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Recommendation') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllRecommendations(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            status: filter.status,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.RECOMMENDATION}`, requestOptions)
}


export function updateRecommendationStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.RECOMMENDATION}/${data.id}`, requestOptions)
}

export function getRecommendation(id) {
    return apiHelper(API_URL).get(`/${MODULE.RECOMMENDATION}/${id}`)
}

export function updateRecommendation(data) {
    const crops = data.crops
        .filter(item => item.pestControls && item.pestControls.length > 0)
        .map(item => ({
            name: item.name.trim(),
            pest_controls: item.pestControls.map(pestControl => ({
                pest_control: pestControl.pestControl.trim(),
                rate: pestControl.rate,
            }))
        }));

    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        status: data.status,
        crops: crops
    }
    return apiHelper(API_URL).put(`/${MODULE.RECOMMENDATION}/${data.id}`, requestOptions)
}

export function createRecommendation(data) {

    const crops = data.crops
        .filter(item => item.pestControls && item.pestControls.length > 0)
        .map(item => ({
            name: item.name.trim(),
            pest_controls: item.pestControls.map(pestControl => ({
                pest_control: pestControl.pestControl.trim(),
                rate: pestControl.rate,
            }))
        }));

    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        status: data.status,
        crops: crops
    }

    return apiHelper(API_URL).post(`/${MODULE.RECOMMENDATION}`, requestOptions)
}